var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArchAmazonKinesisFirehose32(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon-Architecture/32/Arch_Amazon-Kinesis-Firehose_32") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "100%",
    x2: "100%",
    y2: "0%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D27A8",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A166FF",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon-Architecture/32/Arch_Amazon-Kinesis-Firehose_32",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-Architecture-BG/32/Analytics",
    fill: "url(#linearGradient-1)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", {
    id: "Icon-Service/32/Amazon-Kinesis-Data-Firehose",
    transform: "translate(4.000000, 4.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.265,18.536 L28.894,19.465 C26.557,18.53 24.441,18.056 22.604,18.056 L22.604,17.056 C24.568,17.056 26.809,17.554 29.265,18.536 L29.265,18.536 Z M27.363,17.169 C25.773,16.84 24.129,16.5 22.604,16.5 L22.604,15.5 C24.023,15.5 25.557,15.184 27.04,14.879 C27.705,14.743 28.356,14.609 28.977,14.507 L29.139,15.494 C28.53,15.594 27.893,15.725 27.243,15.859 C27.025,15.904 26.804,15.947 26.584,15.992 C26.912,16.057 27.241,16.123 27.565,16.19 C28.114,16.304 28.651,16.415 29.168,16.508 L28.991,17.493 C28.465,17.397 27.919,17.285 27.363,17.169 L27.363,17.169 Z M29.258,13.467 C27.601,14.102 25.107,14.946 22.604,14.946 L22.604,13.946 C24.942,13.946 27.317,13.14 28.901,12.534 L29.258,13.467 Z M20.604,17.61 L15.604,18.86 L15.604,13.141 L20.604,14.391 L20.604,17.61 Z M14.604,20 L12.604,20 L12.604,12 L14.604,12 L14.604,12.5 L14.604,19.5 L14.604,20 Z M21.225,13.515 L15.604,12.11 L15.604,11.5 C15.604,11.224 15.38,11 15.104,11 L12.104,11 C11.828,11 11.604,11.224 11.604,11.5 L11.604,11.833 C4.994,11.351 3.604,9.006 3.604,5.634 L3.604,3 L2.604,3 L2.604,5.634 C2.604,10.225 5.31,12.392 11.604,12.836 L11.604,13.404 C7.758,13.249 5.127,12.65 2.912,11.417 L2.426,12.291 C4.795,13.609 7.57,14.245 11.604,14.405 L11.604,15.478 C8.718,15.402 4.965,15.195 2.256,14.48 L2,15.447 C2.878,15.679 3.862,15.854 4.882,15.994 C3.88,16.137 2.904,16.315 2,16.554 L2.256,17.52 C5.086,16.774 8.67,16.582 11.604,16.513 L11.604,17.596 C7.594,17.754 4.821,18.39 2.428,19.709 L2.911,20.585 C5.151,19.349 7.782,18.751 11.604,18.597 L11.604,19.166 C5.557,19.614 2.607,22.138 2.607,26.885 L2.606,27.088 C2.597,28.759 2.602,28.945 2.61,29.014 L3.605,28.917 C3.596,28.762 3.603,27.579 3.606,27.093 L3.607,26.885 C3.607,22.667 6.085,20.585 11.604,20.167 L11.604,20.5 C11.604,20.777 11.828,21 12.104,21 L15.104,21 C15.38,21 15.604,20.777 15.604,20.5 L15.604,19.89 L21.225,18.485 C21.448,18.43 21.604,18.23 21.604,18 L21.604,14 C21.604,13.771 21.448,13.571 21.225,13.515 L21.225,13.515 Z",
    id: "Amazon-Kinesis-Data-Firehose_Icon_32_Squid"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchAmazonKinesisFirehose32);
export default __webpack_public_path__ + "static/media/Arch_Amazon-Kinesis-Firehose_32.9979de71351c33799a884b61f8046475.svg";
export { ForwardRef as ReactComponent };